module.exports = __webpack_public_path__ + "assets/img/37_1617_big.6412a25c.jpg";